module.exports = "<i class=\"gmw-metal-badge gmw-metal-badge--{{getClass()}}\"> <span ng-bind=getElement()></span> </i> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/metals/directives/metal-badge/metal-badge.html
// module id = 647
// module chunks = 0